import React, { useState } from 'react';
import { UUID } from '../../../types/shared/UUID';
import { ButtonTW } from '../../../tailwindComponents/buttonTW/ButtonTW';
import { ErrorBoundaryTW } from '../../../tailwindComponents/errorBoundary/ErrorBoundaryTW';
import { Show } from '../../shared/Show';
import { AssociateTagForm } from './AssociateTagForm';

export const AssociateTagContainer: React.FC<{
  orderId: UUID;
  setEditTags: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ orderId, setEditTags }) => {
  const [addTag, setAddTag] = useState<boolean>(false);
  return (
    <ErrorBoundaryTW>
      <Show when={addTag} fallback={<ButtonTW onClick={() => setAddTag(true)}>Add Tag</ButtonTW>}>
        <AssociateTagForm currentOrderId={orderId} setAddTag={setAddTag} setEditTags={setEditTags} />
      </Show>
    </ErrorBoundaryTW>
  );
};
